export { GEOJSON_FEATURE_COLLECTION } from 'components/Map/hooks/useFeatures/constants';

export enum FEATURE_SOURCE {
    DRAWING = 'drawing-features-source',
    STATIC = 'static-features-source',
    CLUSTER = 'cluster-features-source'
}

export enum MAPBOX_ZOOM_LEVEL {
    EARTH = 0,
    CONTINENT = 3,
    LARGE_ISLANDS = 4,
    LARGE_RIVERS = 6,
    LARGE_ROADS = 10,
    BUILDINGS = 15,
    MAX = 22
}

export const MAPBOX_ZOOM = {
    max: MAPBOX_ZOOM_LEVEL.MAX,
    min: MAPBOX_ZOOM_LEVEL.EARTH
};

export const CLUSTER_ZOOM = {
    max: MAPBOX_ZOOM_LEVEL.BUILDINGS + 2,
    min: MAPBOX_ZOOM_LEVEL.EARTH
};

export const STATIC_ZOOM = {
    max: MAPBOX_ZOOM.max,
    min: CLUSTER_ZOOM.max
};

export const CLUSTER_RADIUS = 50;

export { GEOJSON_PROPERTY } from 'components/Map/hooks/useFeatures/constants';

export { MAP_LAYER } from 'components/Map/constants';
